import { render, staticRenderFns } from "./TemplatePreviewer.vue?vue&type=template&id=24623705&"
import script from "./TemplatePreviewer.vue?vue&type=script&lang=js&"
export * from "./TemplatePreviewer.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePreviewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports